import { IDirective, IDirectiveFactory, IRootScopeService, IScope } from "angular";
import { AssigneeActions, IAssigneesStoreState } from "@gtmhub/assignees";
import { PlanningSessionsActions } from "@gtmhub/sessions/redux/session-actions";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { INgRedux } from "@gtmhub/state-management";
import { Assignee } from "@webapp/assignees/models/assignee.models";
import { Session } from "@webapp/sessions/models/sessions.model";
import { IGoal, IGoalInTree, IGoalNode } from "../models";

interface IGoalListNodeRedux {
  assigneesIdMap: Record<string, Assignee>;
  sessionsIdMap: Record<string, Session>;
}
const bindStateToScope = (state: IAssigneesStoreState & ISessionsStoreState) => {
  return {
    assigneesIdMap: state.assignees.map,
    sessionsIdMap: state.sessions.map,
  };
};
export interface IGoalListNodeScope extends IGoalListNodeRedux, IScope {
  node: IGoalNode;
  showMetrics: boolean;
  confirmDeleteGoal(goal: IGoal): void;
  toggle(goal: IGoal): void;
  orderMetricsBy: string;
}
export class GoalListNode implements IDirective {
  public scope = {
    node: "=",
    showMetrics: "=",
    progressAggregationDisabled: "<",
  };
  public restrict = "E";
  public transclude = true;
  public template = require("./goal-list-node.html");

  constructor(
    private $rootScope: IRootScopeService,
    private assigneeActions: AssigneeActions,
    private planningSessionsActions: PlanningSessionsActions,
    private $ngRedux: INgRedux
  ) {}

  public link(scope: IGoalListNodeScope): void {
    scope.confirmDeleteGoal = this.confirmDeleteGoal;
    scope.toggle = this.toggle;
    scope.orderMetricsBy = "orderId";

    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(scope);
    scope.$on("$destroy", unsubscribe);
    this.$ngRedux.dispatch(this.assigneeActions.getAssignees());
    this.$ngRedux.dispatch(this.planningSessionsActions.getSessionsIfMissing());
  }

  private toggle = (goal: IGoalInTree) => {
    if (goal.folded === true) {
      goal.folded = false;
    } else {
      goal.folded = true;
    }
  };

  private confirmDeleteGoal = (goal: IGoal) => {
    this.$rootScope.$broadcast("goalsTree.confirmDeleteGoal", goal);
  };

  public static factory(): IDirectiveFactory {
    const directive = ($rootScope: IRootScopeService, assigneeActions: AssigneeActions, planningSessionsActions: PlanningSessionsActions, $ngRedux: INgRedux) =>
      new GoalListNode($rootScope, assigneeActions, planningSessionsActions, $ngRedux);
    directive.$inject = ["$rootScope", "AssigneeActions", "PlanningSessionsActions", "$ngRedux"];
    return directive;
  }
}
